<template>
  <div class="salonDetails">
    <div class="title">{{ New.title }}</div>
    <div class="time">{{ New.publishDate }}</div>
    <div class="newImg">
      <img :src="New.cover" alt />
    </div>
    <div class="text" v-html="New.content"></div>
  </div>
</template>

<script>
import { getNewsDetail } from "@/api/api.js";
export default {
  data() {
    return {
      New: {
        title: "",
        content: "",
        cover: "",
        publishDate: ""
      }
    };
  },
  components: {
    // pay
  },
  mounted() {
    this.toPage(this.$route.query.id);
  },
  methods: {
    toPage(id) {
      if (id) {
        this.getNewsDetail(id);
      } else {
        this.$router.push({ name: "H5gardenPlot" });
      }
    },
    getNewsDetail(id) {
      getNewsDetail(id).then(res => {
        if (res.code === 0) {
          this.New = {
            title: res.data.news.title,
            content: res.data.news.content,
            cover: res.data.news.cover,
            publishDate: res.data.news.publishDate
          };
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    },
    toLink(id) {
      this.getNewsDetail(id);
    }
  }
};
</script>

<style lang="less">
.salonDetails {
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  .title {
    margin-bottom: 10px;
    font-size: 18px;
    color: #343434;
    text-align: justify;
  }
  .time {
    margin-bottom: 10px;
    font-size: 14px;
    color: #999999;
    text-align: justify;
    line-height: 14px;
  }
  .newImg {
  }
  .text {
    font-size: 14px;
    color: #343434;
    text-align: justify;
    line-height: 22px;
  }
  .d-button {
    margin: 50px auto 0;
    width: 140px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    background: #6c2c66;
    color: #fff;
    border-radius: 2px;
  }
}
</style>
